import Tag from "./Tag";

export type TagListProps = {
  tag: string[];
  background?: boolean;
};

/**
 * タグ（リスト）
 */
export default function TagList({ tag, background = false }: TagListProps) {
  return (
    <div className="mt-3 flex flex-wrap gap-2">
      {tag.map((tag, index) => {
        if (!tag.length) {
          return;
        }

        return (
          <Tag
            key={`${tag}-${index}`}
            title={tag}
            background={background}
          />
        );
      })}
    </div>
  );
}
